import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { ConspretratamientoUpdate } from "./ConspretratamientoUpdate";
import { ConspretratamientoDelete } from "./ConspretratamientoDelete";

export function ConspretratamientoEdit(props) {
  const conspretratamiento = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = conspretratamiento.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [conspretResp, setConspretResp] = useState(
    conspretratamiento.meta?.conspretResp
  );
  const [metaFecha, setConspretFecha] = useState(
    conspretratamiento.meta?.metaFecha
  );
  const [conspretMedio, setConspretMedio] = useState(
    conspretratamiento.meta?.conspretMedio
  );
  const [conspretTipo, setConspretTipo] = useState(
    conspretratamiento.meta?.conspretTipo
  );
  const [conspretObs, setConspretObs] = useState(
    conspretratamiento.meta?.conspretObs
  );
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let conspretratamientoId = conspretratamiento.id;

  const conspretDate = new Date(conspretratamiento.date);
  const diffDate = (Math.abs(new Date() - conspretDate) / 36e5);

  const submitConspretratamiento = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await ConspretratamientoUpdate(
        conspretResp,
        metaFecha,
        conspretMedio,
        conspretTipo,
        conspretObs,
        tratamientoId,
        pacienteId,
        conspretratamientoId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/antecedentes/consulta-pre-tratamiento/${conspretratamientoId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await ConspretratamientoDelete(
        conspretratamientoId
      ).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {conspretratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitConspretratamiento}>
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='conspretResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='conspretResp'
                      required
                      type='text'
                      value={conspretResp}
                      onChange={(e) => setConspretResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      value={metaFecha}
                      onChange={(e) => setConspretFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspretMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspretMedio'
                        required
                        name='conspretMedio'
                        value={conspretMedio}
                        onChange={(e) => setConspretMedio(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                        <option value='telefonico'>Telefónico</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspretTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspretTipo'
                        required
                        name='conspretTipo'
                        value={conspretTipo}
                        onChange={(e) => setConspretTipo(e.target.value)}
                      >
                        {( props.userRole.includes('administrador')) ?
                          <>
                          <option disabled value=''>-- Selecciona una opción --</option>
                          <option value='medica'>Médica</option>
                          <option value='psicologica'>Psicológica</option>
                          <option value='psiquiatrica'>Psiquiátrica</option>
                          <option value='ypsilon'>Ypsilon ambulatorio</option>
                        </>
                        : ( props.userRole.includes('medicina')) ?
                        <>
                          <option disabled value=''>-- Selecciona una opción --</option>
                          <option value='medica'>Médica</option>
                        </>
                        : ( props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia')) ?
                        <>
                          <option disabled value=''>-- Selecciona una opción --</option>
                          <option value='psicologica'>Psicológica</option>
                          <option value='psiquiatrica'>Psiquiátrica</option>
                          <option value='ypsilon'>Ypsilon ambulatorio</option>
                        </>
                        :
                          <option disabled value=''>Sin Permisos</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label htmlFor='conspretObs'>Observaciones</label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='conspretObs'
                    id='conspretObs'
                    value={conspretObs}
                    onChange={(e) => setConspretObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
         ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) && ((props.userRole.includes('psicologia-hospital') && conspretTipo === "psicologica") || (props.userRole.includes('psicologia') && conspretTipo === "psicologica") || (props.userRole.includes('medicina') && conspretTipo === "medica")) || (props.userRole.includes('administrador')))  &&
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        }
        <Link
          className='button is-link is-light'
          to={`../${tratamientoId}/antecedentes/consulta-pre-tratamiento/${conspretratamiento.id}`}
        >
          Cancelar
        </Link>
        {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}
